import ValoresRepository from '@/services/ValoresRepository'

export default {
  namespaced: true,
  state: {
    listaRetiros: []
  },
  getters:{
    getRetiro: (state) => (idRetiro) => {
      return state.listaRetiros.find(retiro => retiro.idRetiro === idRetiro)
    },
  },
  mutations: {
    setListaRetiros(state, listaRetiros){
      state.listaRetiros = listaRetiros
    },

    clearListaRetiros(state){
      state.listaRetiros = []
    }

  },
  actions: {
    async fetchListaRetiros({state, commit, rootState, rootGetters}){
      if(state.listaRetiros && state.listaRetiros.length > 0){
        return
      }
      let idEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let idGrupoExplotacion = rootGetters['establecimientos/ganaderiaExplotacion'].idGrupoExplotacion
      
      if(idEstablecimiento !== 0 && idGrupoExplotacion!==0){
        let retiros = await ValoresRepository.listaRetiros(idEstablecimiento, idGrupoExplotacion) || []
        commit('setListaRetiros', retiros)
      }
    },

    clearListaRetiros({commit}){
      commit('clearListaRetiros')
    }
  }
}